import { typeCreatorV2 } from 'redux/utils/common';

// //  [REDUCER][TYPE]
export const SET_ONE_BLOG: string = typeCreatorV2(
  'BLogEditReducer',
  'SetOneBlog'
);

export const UPDATE_BLOG: string = typeCreatorV2(
  'BLogEditReducer',
  'UpdateBlog'
);

export const SET_SEGMENTS: string = typeCreatorV2(
  'BLogEditReducer',
  'SetSegmentBlog'
);

export const UPDATE_DESCRIPTION_BLOG_TEMPORARY: string = typeCreatorV2(
  'BLogEditReducer',
  'UpdateDescriptionBlog'
);

export const UPDATE_TITLE_BLOG_TEMPORARY: string = typeCreatorV2(
  'BLogEditReducer',
  'UpdateTitleBlog'
);
